class selectTaxon extends HTMLElement {
  constructor() {
    super();
    this.$el = this.querySelector('select');
    this.$alert = this.querySelector('.alert');
  }

  connectedCallback() {
    this.$el.addEventListener('change', this.onChange.bind(this));
  }

  disconnectedCallback() {
    this.$el.removeEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    const value = event.target.value;
    if (value !== 'general') {
      this.$alert.classList.remove('hidden');
    } else {
      this.$alert.classList.add('hidden');
    }
  }
}

customElements.define("select-note-type", selectTaxon);

export default selectTaxon;